(function () {
  var cfg = window.vcPerf || {};
  var abandonMs = (cfg.abandonMinutes || 30) * 60 * 1000;
  var storageKey = 'vc_cart_last_activity';
  var dismissKey = 'vc_cart_recovery_dismiss';
  var shownKey = 'vc_cart_recovery_shown';

  function money(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
      }
    } catch (e) {}
    return 'S/. ' + (cents / 100).toFixed(2);
  }

  function buildWhatsAppText(cart) {
    var lines = ['Hola, dejé productos en mi carrito y quiero terminar mi compra:'];
    cart.items.slice(0, 5).forEach(function (item, i) {
      lines.push((i + 1) + '. ' + item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' — ' + item.variant_title : '') + ' x' + item.quantity + ' (' + money(item.final_line_price) + ')');
    });
    if (cart.items.length > 5) lines.push('... y ' + (cart.items.length - 5) + ' producto(s) más');
    lines.push('Total: ' + money(cart.total_price));
    lines.push(location.origin + '/cart');
    return lines.join('\n');
  }

  function removeBanner() {
    var el = document.getElementById('vc-cart-recovery');
    if (el) el.remove();
    document.documentElement.classList.remove('vc-cart-recovery-active');
  }

  function showBanner(cart) {
    if (document.getElementById('vc-cart-recovery')) return;
    if (sessionStorage.getItem(dismissKey)) return;

    var phone = cfg.wspPhone || '';
    var wspHref = phone
      ? 'https://wa.me/' + phone + '?text=' + encodeURIComponent(buildWhatsAppText(cart))
      : '/cart';

    var wrap = document.createElement('div');
    wrap.id = 'vc-cart-recovery';
    wrap.className = 'vc-cart-recovery vc-cart-recovery--' + (cfg.store || 'store');
    wrap.innerHTML =
      '<div class="vc-cart-recovery__inner">' +
        '<p class="vc-cart-recovery__text"><strong>Tienes ' + cart.item_count + ' producto' + (cart.item_count === 1 ? '' : 's') + ' en tu carrito.</strong> ¿Terminamos tu compra?</p>' +
        '<div class="vc-cart-recovery__actions">' +
          '<a class="vc-cart-recovery__btn vc-cart-recovery__btn--primary" href="/cart">Ver carrito</a>' +
          (phone ? '<a class="vc-cart-recovery__btn vc-cart-recovery__btn--wsp" href="' + wspHref + '" target="_blank" rel="noopener nofollow">WhatsApp</a>' : '') +
          '<button type="button" class="vc-cart-recovery__close" aria-label="Cerrar">×</button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(wrap);
    document.documentElement.classList.add('vc-cart-recovery-active');
    sessionStorage.setItem(shownKey, String(Date.now()));

    wrap.querySelector('.vc-cart-recovery__close').addEventListener('click', function () {
      sessionStorage.setItem(dismissKey, '1');
      removeBanner();
    });
  }

  function touchActivity() {
    try {
      localStorage.setItem(storageKey, String(Date.now()));
    } catch (e) {}
  }

  function shouldRecover() {
    try {
      var last = parseInt(localStorage.getItem(storageKey) || '0', 10);
      if (!last) return false;
      return Date.now() - last >= abandonMs;
    } catch (e) {
      return false;
    }
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function maybeRecover() {
    if (!shouldRecover()) return;
    fetchCart().then(function (cart) {
      if (cart && cart.item_count > 0) showBanner(cart);
    }).catch(function () {});
  }

  function init() {
    touchActivity();
    if ((window.theme && window.theme.cartCount > 0) || document.querySelector('[data-item-count]')) {
      maybeRecover();
    } else {
      fetchCart().then(function (cart) {
        if (cart.item_count > 0) maybeRecover();
      }).catch(function () {});
    }

    document.addEventListener('cart:refresh', touchActivity);
    document.addEventListener('cart:updated', touchActivity);
    document.addEventListener('variant:changed', touchActivity);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) maybeRecover();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
